import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { NewModalModule } from 'outshared-lib';
import { AppointmentConfirmationModal } from '../appointment-confirmation-modal/appointment-confirmation.modal';

@NgModule({
    declarations: [AppointmentConfirmationModal],
    exports: [AppointmentConfirmationModal],
    imports: [
        CommonModule,
        PipesModule,
        NewModalModule,
    ],
})
export class AppointmentConfirmationModalModule {
}
